// Jornada de Conversão (preroll/postroll) — vídeo de entrada antes do principal
// e/ou de saída depois, estilo anúncio do YouTube. Fonte SEMPRE da biblioteca
// (vídeos já cadastrados, referenciados por libraryVideoId) — sem upload/URL
// externa. Portado do protótipo dopamine-spark-app (types/video-preroll.ts),
// renomeado VideoPreroll -> ConversionJourney.

export type PrerollSourceType = 'library';
export type PrerollAfterAction = 'auto_start_main' | 'wait_for_click';
export type PrerollCtaOpenMode = 'new_tab' | 'same_tab';
export type PrerollCtaPosition = 'bottom_center' | 'bottom_left' | 'center';
export type PrerollSkipPosition = 'top_right' | 'bottom_right' | 'bottom_center';
export type PrerollStyleVariant = 'dark_premium' | 'light_premium' | 'minimalist';
export type PrerollFrequency = 'always' | 'once_per_visitor' | 'after_24h' | 'after_7d';
export type PrerollSkipAfter = 3 | 5 | 10 | 15 | 30 | 'custom';

// FlowLayer (entrada + saída)
export type FlowLayerPlacement = 'before' | 'after' | 'before_and_after';
export type ExitStartMode = 'auto_after_main' | 'show_start_button' | 'delay_after_main';

export interface FlowLayerExit {
  enabled: boolean;
  // Source (sempre biblioteca)
  sourceType: PrerollSourceType;
  libraryVideoId?: string | null;
  libraryVideoName?: string;
  libraryVideoDuration?: string;
  libraryVideoThumbnail?: string;
  // When to start
  startMode: ExitStartMode;
  startDelaySeconds: number;
  startButtonText: string;
  // CTA
  ctaEnabled: boolean;
  ctaImage?: string;
  ctaTitle: string;
  ctaDescription: string;
  ctaText: string;
  ctaUrl: string;
  ctaShowAfterSec: number;
  ctaOpenMode: PrerollCtaOpenMode;
  ctaPosition: PrerollCtaPosition;
  // Ações finais
  showReplayButton: boolean;
  allowClose: boolean;
  showBackToMainButton: boolean;
  replayText: string;
  closeText: string;
  backText: string;
  // Aparência
  showBadge: boolean;
  badgeText: string;
  styleVariant: PrerollStyleVariant;
  primaryColor: string;
}

export interface ConversionJourney {
  enabled: boolean;

  // FlowLayer placement (default: before)
  placementMode?: FlowLayerPlacement;

  // ===== Vídeo de entrada =====
  // Source (sempre biblioteca)
  sourceType: PrerollSourceType;
  libraryVideoId?: string | null;
  libraryVideoName?: string;
  libraryVideoDuration?: string;
  libraryVideoThumbnail?: string;

  // Skip
  skipEnabled: boolean;
  skipAfter: PrerollSkipAfter;
  skipAfterCustomSec: number;
  skipButtonText: string;
  skipCountdownText: string;

  // After preroll
  afterAction: PrerollAfterAction;
  startButtonText: string;

  // CTA
  ctaEnabled: boolean;
  ctaTitle: string;
  ctaDescription: string;
  ctaText: string;
  ctaUrl: string;
  ctaImage?: string;
  ctaShowAfterSec: number;
  ctaOpenMode: PrerollCtaOpenMode;
  ctaPosition: PrerollCtaPosition;

  // Appearance
  styleVariant: PrerollStyleVariant;
  primaryColor: string;
  showBadge: boolean;
  badgeText: string;
  skipButtonPosition: PrerollSkipPosition;

  // Frequency
  frequency: PrerollFrequency;

  // ===== Vídeo de saída =====
  exit?: FlowLayerExit;
}

export const defaultFlowLayerExit: FlowLayerExit = {
  enabled: false,
  sourceType: 'library',
  libraryVideoId: null,
  libraryVideoName: '',
  libraryVideoDuration: '',
  libraryVideoThumbnail: '',
  startMode: 'auto_after_main',
  startDelaySeconds: 3,
  startButtonText: 'Assistir próximo passo',
  ctaEnabled: true,
  ctaImage: '',
  ctaTitle: 'Próximo passo da sua jornada',
  ctaDescription: 'Continue agora mesmo',
  ctaText: 'Quero acessar agora',
  ctaUrl: '',
  ctaShowAfterSec: 0,
  ctaOpenMode: 'new_tab',
  ctaPosition: 'bottom_center',
  showReplayButton: true,
  allowClose: true,
  showBackToMainButton: false,
  replayText: 'Assistir novamente',
  closeText: 'Fechar',
  backText: 'Voltar ao vídeo principal',
  showBadge: true,
  badgeText: 'Próximo passo',
  styleVariant: 'dark_premium',
  primaryColor: '#2563FF',
};

export const defaultConversionJourney: ConversionJourney = {
  enabled: false,
  placementMode: 'before',

  sourceType: 'library',
  libraryVideoId: null,
  libraryVideoName: '',
  libraryVideoDuration: '',
  libraryVideoThumbnail: '',

  skipEnabled: true,
  skipAfter: 5,
  skipAfterCustomSec: 8,
  skipButtonText: 'Pular',
  skipCountdownText: 'Pular em {segundos}s',

  afterAction: 'auto_start_main',
  startButtonText: 'Assistir próximo vídeo',

  ctaEnabled: false,
  ctaTitle: 'Diagnóstico Comercial Gratuito',
  ctaDescription: '',
  ctaText: 'Saiba mais',

  ctaUrl: '',
  ctaShowAfterSec: 5,
  ctaOpenMode: 'new_tab',
  ctaPosition: 'bottom_center',

  styleVariant: 'dark_premium',
  primaryColor: '#2563FF',
  showBadge: true,
  badgeText: 'Vídeo de entrada',
  skipButtonPosition: 'top_right',

  frequency: 'always',

  exit: defaultFlowLayerExit,
};
